<template>
  <div>
    <!-- Loading Spinner -->
    <div class="loading" v-if="fetchData">
      <load-data></load-data>
    </div>

    <!-- Student Form -->
    <div class="addStudents" v-else>
      <b-form @submit.prevent="createStudents">

        <!-- Open Elective / Minor Course Type -->
        <div class="row" v-if="['open_elective', 'minor'].includes(course.type.slug)">

          <!-- Institution Selection -->
          <div class="col-sm-6 col-md-4 col-lg-3" v-for="(option, index) in institutions" :key="index">
            <b-form-checkbox
              v-if="institutions.length > 1"
              :disabled="fromSubgroupsIds.length > 0"
              v-model="fromInstitutionId"
              :value="option.value"
              @change="loadInstitutionSubGroup(option.value)"
              :checked="institutions.length === 1"
            >
              {{ option.text }}
            </b-form-checkbox>
          </div>

          <!-- Subgroup Selection -->
          <div class="row">
            <div class="col-sm-6 col-md-4 col-lg-3" v-for="(option, index) in institutionSubgroupOptions" :key="index">
              <b-form-checkbox
                v-model="fromSubgroupsIds"
                :value="option.value"
                @change="updateFromSubgroupsStudentsOptions(option.value)"
              >
                {{ option.text }}
              </b-form-checkbox>
            </div>
          </div>
          <span class="text-danger" v-if="selectedInstitutionId && institutionSubgroupOptions.length == 0">
            <br>
            No classes are created for {{institutions.find(i => i.value === selectedInstitutionId).text}} in the {{ courseStudentModal.academic_year }}-{{ courseStudentModal.academic_semester }} academic year.
          </span>


          <!-- Student List Table -->
          <table v-if="fromSubgroupsIds.length" class="table table-striped table-bordered">
            <thead>
              <tr style="background-color: #a8a8a8;">
                <th v-for="(subgroupId, subgindex) in fromSubgroupsIds" :key="subgindex">
                  {{ institutionSubgroupOptions.find(obj => obj.value == subgroupId).text }}
                </th>
              </tr>
            </thead>
            <tbody style="font-weight: 300;">
              <tr>
                <td v-for="subgroupId in fromSubgroupsIds" :key="subgroupId">
                  <b-link
                    v-if="subgroupsStudentsOptions[subgroupId] && subgroupsStudentsOptions[subgroupId].length > 1"
                    @click="selectAllStudentsOn(subgroupId)"
                  >Select All</b-link>
                </td>
              </tr>
              <tr>
                <td v-for="subgroupId in fromSubgroupsIds" :key="subgroupId">
                  <span v-for="(stud, index) in subgroupsStudentsOptions[subgroupId]" :key="index">
                    <b-form-checkbox v-model="fromSubgroupsSelectedStudentIds" :value="stud.id">
                      {{ stud.name }}
                    </b-form-checkbox>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>

        </div>

        <!-- Non-elective Courses -->
        <div v-else>
          <div v-if="interDepartmentStudentsEnroll">
            <div class="row">
              <div class="col-sm-6 col-md-4 col-lg-3" v-for="(option, index) in subgroupOptions" :key="index">
                <b-form-checkbox
                  v-model="fromSubgroupsIds"
                  :value="option.value"
                  @change="updateFromSubgroupsStudentsOptions(option.value)"
                >
                  {{ option.text }}
                </b-form-checkbox>
              </div>
            </div>

            <!-- Student List Table -->
            <table v-if="fromSubgroupsIds.length" class="table table-striped table-bordered">
              <thead>
                <tr style="background-color: #a8a8a8;">
                  <th v-for="subgroupId in fromSubgroupsIds" :key="subgroupId">
                    {{ subgroupOptions.find(obj => obj.value == subgroupId).text }}
                  </th>
                </tr>
              </thead>
              <tbody style="font-weight: 300;">
                <tr>
                  <td v-for="subgroupId in fromSubgroupsIds" :key="subgroupId">
                    <b-link
                      v-if="subgroupsStudentsOptions[subgroupId].length > 1"
                      @click="selectAllStudentsOn(subgroupId)"
                    >Select All</b-link>
                  </td>
                </tr>
                <tr>
                  <td v-for="subgroupId in fromSubgroupsIds" :key="subgroupId">
                    <span v-for="(stud, index) in subgroupsStudentsOptions[subgroupId]" :key="index">
                      <b-form-checkbox v-model="fromSubgroupsSelectedStudentIds" :value="stud.id">
                        {{ stud.name }}
                      </b-form-checkbox>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>

          </div>

          <!-- Fallback Multiselect -->
          <b-form-group v-else>
            <multiselect
              v-model="selectedStudents"
              tag-placeholder="Add this as new tag"
              :placeholder="'Add Students for ' + courseStudentModal.name"
              label="name"
              track-by="code"
              :options="StudentOptions"
              :close-on-select="false"
              :multiple="true"
              :taggable="true"
              @tag="addStudent"
            />
          </b-form-group>
        </div>

        <!-- Form Buttons -->
        <b-form-group>
          <div class="d-flex justify-content-between flex-wrap">
            <b-button
              v-if="selectedStudents.length || fromSubgroupsSelectedStudentIds.length"
              variant="primary"
              size="sm"
              :disabled="addAdminBtn.disabled"
              type="submit"
            >
              {{ addAdminBtn.text }}
            </b-button>

            <b-button
              variant="danger"
              @click="$emit('addStudentStatus', false)"
              size="sm"
              :disabled="addAdminBtn.disabled"
            >
              Cancel
            </b-button>
          </div>
        </b-form-group>

      </b-form>
    </div>
  </div>
</template>

<script>
export default {
  async created() {
    this.fetchData = true;
    this.usersubgroup_id = this.courseStudentModal.usersubgroup_id;
    await this.prepareExistingStudents();
    await this.getCourse();
    await this.getInstitutionGroupInstitutions();
    if (
      this.course.type.slug == "open_elective" ||
      this.course.type.slug == "minor" ||
      this.course.type.slug == "elective"
    ) {
      this.selectedStudents = [];
      this.StudentOptions = [];
      this.interDepartmentStudentsEnroll = true;
      await this.getAcademicYearSubgroups();
      // if (this.subgroupOptions.length > 0) {
      //   this.usersubgroup_id = this.subgroupOptions[0].value;
      //   await this.getSubgroupUsers();
      // }
    } else {
      await this.getSubgroupUsers();
    }
    this.fetchData = false;
  },
  props: ["courseStudentModal", "courseStudentsList"],
  data() {
    return {
      institutions: [],
      selectedInstitutionId: null,
      selectedStudents: [],
      StudentOptions: [],
      addAdminBtn: {
        text: "Submit",
        disabled: false,
      },
      course: null,
      interDepartmentStudentsEnroll: false,
      fetchData: false,
      existingStudents: {},
      institutionSubgroupOptions: [],
      subgroupOptions: [],
      fromSubgroupsIds: [],
      fromInstitutionId: null,
      subgroupsStudentsOptions: {},
      fromSubgroupsSelectedStudentIds: [],
      usersubgroup_id: null,
    };
  },
  computed: {
    getCustomNames() {
      return this.$store.getters.getCustomNamings;
    },
  },
  methods: {
    selectAllStudentsOn(subgroupId) {
      this.subgroupsStudentsOptions[subgroupId].forEach(stud => {
        setTimeout(() => {
          this.fromSubgroupsSelectedStudentIds.push(stud.id);
        }, 100);
      });
    },
    updateFromSubgroupsStudentsOptions(subgroupId) {
      if (this.fromSubgroupsIds.includes(subgroupId)) {
        this.usersubgroup_id = subgroupId;
        this.getSubgroupUsers();
      }
    },
    async createStudents() {
      this.addAdminBtn = {
        text: "Please wait...",
        disabled: true,
      };

      const url =
        this.$store.getters.getAPIKey.mainAPI + `/course/${this.courseStudentModal.id}/interdepartmentalstudents`;

      const students = {
        institution_users: [],
      };

      // Add from inter-department students (checkbox table)
      this.fromSubgroupsSelectedStudentIds.forEach((id) => {
        // Find student from subgroupsStudentsOptions to get roll_number
        for (const subgroupId in this.subgroupsStudentsOptions) {
          const student = this.subgroupsStudentsOptions[subgroupId].find(s => s.id === id);
          if (student) {
            students.institution_users.push({
              institution_user_id: student.id,
              roll_number: student.roll_number || null
            });
          }
        }
      });

      // Add from multiselect
      this.selectedStudents.forEach((student) => {
        students.institution_users.push({
          institution_user_id: student.id,
          roll_number: student.roll_number || null // Assuming roll_number is available
        });
      });

      await this.$axios
        .post(url, {
          students: students,
          InstitutionId: this.fromInstitutionId
        }
        )
        .then(() => {
          this.$toast.success(
            `Students added to ${this.courseStudentModal.name}`,
            {
              position: "top",
              duration: 3000,
            }
          );
          this.$emit("addStudentStatus", true);
          // console.log(response);
        })
        .catch(() => {
          // console.log(error);
        });
      this.addAdminBtn = {
        text: "Please wait...",
        disabled: true,
      };
    },
    async getSubgroupUsers() {
      this.postCourses = true;
      let mainUrl = this.$store.getters.getAPIKey.getEnrollSubgroupUsersList;
      var url = mainUrl.replace("usersubgroup_id", this.usersubgroup_id);
      url = url + `?course=${this.courseStudentModal.id}`;
      // this.StudentOptions = [];
      // await this.getInstitutionStudents();
      await this.$axios
        .get(url)
        .then((response) => {
          this.selectedStudents = [];
          this.StudentOptions = [];
          let students = response.data;
          this.subgroupsStudentsOptions[this.usersubgroup_id] = [];
          students.forEach((staff) => {
            if (
              staff.pivot.usersubgrouprole_id == 2 &&
              !this.existingStudents[staff.pivot.institution_user_id] && staff.enroll_status == 'active'
            ) {
              if (!this.interDepartmentStudentsEnroll) {
                this.StudentOptions.push({
                  name: staff.first_name + " " + (staff.last_name || "") + `( ${staff.email} - ${staff.register_no ?? ''})`,
                  id: staff.pivot.institution_user_id,
                  code: staff.id,
                });
              } else {
                this.subgroupsStudentsOptions[this.usersubgroup_id].push({
                  name: (staff.roll_number ?? '') + ' ' + staff.first_name + " " + (staff.last_name || ""),
                  id: staff.pivot.institution_user_id,
                  roll_number: staff.roll_number
                });
              }
            }
          });
          this.$forceUpdate();

          // console.log(response);
        })
        .catch(() => {
          // console.log(error.response);
        });

      this.fetchData = false;
    },
    async prepareExistingStudents() {
      this.existingStudents = {};
      await this.courseStudentsList.forEach((student) => {
        this.$set(
          this.existingStudents,
          student.institution_user_id,
          student.institution_user_id
        );
      });
    },
    addStudent(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
        id: newTag,
      };
      this.StudentOptions.push(tag);
      this.selectedStudents.push(tag);
    },

    async getCourse() {
      let url =
        this.$store.getters.getAPIKey.mainAPI +
        `/courses/${this.courseStudentModal.id}`;
      await this.$axios.get(url).then((response) => {
        this.course = response.data;
      });
    },
    async getInstitutionGroupInstitutions() {
      let url =
        this.$store.getters.getAPIKey.mainAPI +
        `/institutions?is_institutiongroup=1&course_type=${this.course.type.slug}`;
      await this.$axios.get(url).then((response) => {
        this.institutions = [];
        response.data.forEach((institution) => {
          this.institutions.push({
            text: institution.name + "-" + institution.code,
            value: institution.id,
          });
        });
        // If there's only one institution, automatically select it
        if (this.institutions.length === 1) {
          this.fromInstitutionId = this.institutions[0].value;
          this.loadInstitutionSubGroup(this.institutions[0].value);
        }
      });
    },
    async loadInstitutionSubGroup(institutionId) {
      this.selectedInstitutionId = institutionId;
      let url =
        this.$store.getters.getAPIKey.mainAPI +
        `/institutionuser/usersubgroups?institution=${institutionId}&course_type=${this.course.type.slug}&usergroup_id=${this.courseStudentModal.usergroup_id}`;
      await this.$axios.get(url).then((response) => {
        this.institutionSubgroupOptions = [];
        response.data.forEach((subgroup) => {
          this.institutionSubgroupOptions.push({
            text: subgroup.name + "-" + subgroup.usergroup.code,
            value: subgroup.id,
          });
        });
      });
    },
    async getAcademicYearSubgroups() {
      let url =
        this.$store.getters.getAPIKey.mainAPI +
        `/usersubgroups?course=${this.courseStudentModal.id}`;
      await this.$axios.get(url).then((response) => {
        this.subgroupOptions = [];
        response.data.forEach((subgroup) => {
          this.subgroupOptions.push({
            text: subgroup.name + "-" + subgroup.usergroup.code,
            value: subgroup.id,
          });
        });
      });
    },
  },
};
</script>
